/*
 * product-included-checklist.js — variant-aware checklist visibility.
 *
 * Does NOT loop every variant into the DOM (Shopify Liquid + embedded
 * product JSON cap at 250). Instead:
 *   - Bootstrap map: `.product-included-checklist__map` (first 250)
 *   - Full matrix: merge from `product-variants:loaded` (?view=variants
 *     entries include heirest_soa / igi_certification /
 *     third_party_jewellers_report — see product-variant-matrix-entry)
 *   - Toggle: `variant:update` + metal-switch map swaps
 */
(function () {
  var KEYS = ['heirest_soa', 'igi_certification', 'third_party_jewellers_report'];

  function isTruthy(value) {
    return value === true || value === 'true' || value === 'True';
  }

  function flagsFromVariant(variant) {
    if (!variant) return null;
    var out = {};
    var hasAnyKey = false;
    for (var i = 0; i < KEYS.length; i++) {
      var key = KEYS[i];
      if (Object.prototype.hasOwnProperty.call(variant, key)) {
        hasAnyKey = true;
        out[key] = isTruthy(variant[key]);
      }
    }
    return hasAnyKey ? out : null;
  }

  function readMapNear(root) {
    var scope = root && root.parentElement ? root.parentElement : document;
    var node = scope.querySelector('.product-included-checklist__map');
    if (!node || !node.textContent) return {};
    try {
      return JSON.parse(node.textContent) || {};
    } catch (_e) {
      return {};
    }
  }

  function mergeMapFromVariants(map, variants) {
    var next = Object.assign({}, map || {});
    if (!variants || !variants.length) return next;
    for (var i = 0; i < variants.length; i++) {
      var flags = flagsFromVariant(variants[i]);
      if (!flags || variants[i].id == null) continue;
      next[String(variants[i].id)] = flags;
    }
    return next;
  }

  function writeMapNear(root, map) {
    var scope = root && root.parentElement ? root.parentElement : document;
    var node = scope.querySelector('.product-included-checklist__map');
    if (!node) return;
    try {
      node.textContent = JSON.stringify(map || {});
    } catch (_e) {
      /* ignore */
    }
  }

  function resolveFlags(root, variantId, variant) {
    var fromVariant = flagsFromVariant(variant);
    if (fromVariant) return fromVariant;

    var map = readMapNear(root);
    var hit = map[String(variantId)];
    if (hit) {
      return {
        heirest_soa: isTruthy(hit.heirest_soa),
        igi_certification: isTruthy(hit.igi_certification),
        third_party_jewellers_report: isTruthy(hit.third_party_jewellers_report),
      };
    }
    return null;
  }

  function applyFlags(root, flags) {
    if (!root) return;
    var anyVisible = false;
    var items = root.querySelectorAll('[data-checklist-key]');
    for (var i = 0; i < items.length; i++) {
      var key = items[i].getAttribute('data-checklist-key');
      var show = !!(flags && flags[key]);
      if (show) {
        items[i].removeAttribute('hidden');
        anyVisible = true;
      } else {
        items[i].setAttribute('hidden', '');
      }
    }
    if (anyVisible) root.removeAttribute('hidden');
    else root.setAttribute('hidden', '');
  }

  function applyForVariant(scope, variantId, variant) {
    if (!variantId) return;
    var roots = (scope || document).querySelectorAll('[data-included-checklist]');
    for (var r = 0; r < roots.length; r++) {
      var root = roots[r];
      root.setAttribute('data-current-variant-id', String(variantId));
      applyFlags(root, resolveFlags(root, variantId, variant));
    }
  }

  function onVariantUpdate(event) {
    var detail = event && event.detail;
    var resource = detail && detail.resource;
    var variantId = resource && resource.id;
    if (!variantId) return;

    var sourceSection =
      event.target && event.target.closest ? event.target.closest('.shopify-section') : null;
    applyForVariant(sourceSection || document, variantId, resource);
  }

  function onVariantsLoaded(event) {
    var detail = (event && event.detail) || {};
    var variants = detail.variants || [];
    var formRoot = detail.root;
    var section =
      (formRoot && formRoot.closest && formRoot.closest('.shopify-section')) || document;

    var roots = section.querySelectorAll('[data-included-checklist]');
    for (var r = 0; r < roots.length; r++) {
      var root = roots[r];
      var map = mergeMapFromVariants(readMapNear(root), variants);
      writeMapNear(root, map);

      var variantId =
        root.getAttribute('data-current-variant-id') ||
        (formRoot &&
          formRoot.querySelector &&
          formRoot.querySelector('[data-product-form-variant-id], [name="id"]') &&
          formRoot.querySelector('[data-product-form-variant-id], [name="id"]').value);

      if (!variantId) continue;
      var variant = null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(variantId)) {
          variant = variants[i];
          break;
        }
      }
      applyFlags(root, resolveFlags(root, variantId, variant));
    }
  }

  document.addEventListener('variant:update', onVariantUpdate);
  document.addEventListener('product-variants:loaded', onVariantsLoaded);
})();
